import React from 'react'
import { courses } from '../../utilities/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

const CourseList = ({ handleCourseSelection }) => {

    return (
        <div className='flex flex-col mt-3'>
            {courses?.map((item, index) => {
                const firstElement = index === 0
                const lastElement = index === courses?.length - 1
                return (<div key={index} className={`${courses?.length === 1 ? 'rounded-xl' : firstElement ? 'rounded-t-xl' : lastElement ? 'rounded-b-xl' : ''} ${!lastElement && 'border-b border-[#355D85]'} px-4 py-3 bg-bg-13/[15%] flex gap-2 justify-between`} onClick={() => handleCourseSelection(item, index)}>
                    <img src={item?.image} width={24} height={24} alt="" />
                    <p className='flex-1 text-sm font-medium'>{item?.name}</p>
                    <FontAwesomeIcon icon={faChevronRight} />
                </div>
            )})}
        </div>
    )
}

export default CourseList